import React, { useEffect } from "react";
import { getInvestorApiUrl, getAPIMKey } from "../utils/config"; // Assuming this function provides the base URL.



const DocRender = () => {


    //need to redirect on specific url
    useEffect(() => {
        window.location.href = `${getInvestorApiUrl()}/PassportAccountAgreement?subscription-key=${getAPIMKey()}`
    }, [])

  return <></>
};

export default DocRender;